module.exports = __webpack_public_path__ + "static/media/img4.4ed86d5b.jpg";